import Vue from 'vue';
import { sortBy } from 'lodash';

const namespaced = true;

const defaultState = () => [
  { rolePermissionId: 1, disabled: true },
  { rolePermissionId: 2, disabled: true },
  { rolePermissionId: 3, disabled: true },
  { rolePermissionId: 4, disabled: true },
  { rolePermissionId: 5, disabled: true },
  { rolePermissionId: 6, disabled: true },
  { rolePermissionId: 7, disabled: true },
  { rolePermissionId: 8, disabled: true },
  { rolePermissionId: 9, disabled: true },
  { rolePermissionId: 10, disabled: true },
  { rolePermissionId: 11, disabled: true },
  { rolePermissionId: 12, disabled: true },
  { rolePermissionId: 13, disabled: true },
  { rolePermissionId: 14, disabled: true },
  { rolePermissionId: 15, disabled: true }
];

const state = {
  items: [],
  permissions: [...defaultState()]
};

const getters = {
  items: state => state.items,
  permissions: state => state.permissions
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  },
  SET_PERMISSION: (state, payload) => {
    state.permissions.forEach((permission, index) => {
      Vue.set(state.permissions, index, { ...permission, ...payload[index], disabled: false });
    });
  },
  RESET_PERMISSION: state => {
    const defaultPermission = defaultState();
    state.permissions.forEach((permission, index) => {
      Vue.set(state.permissions, index, { ...permission, ...defaultPermission[index] });
    });
  }
};

const actions = {
  async fetchList({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get('/api/role');

      commit('SET_ITEM', data);
    } catch (err) {
      throw err;
    }
  },

  async fetchPermission({ commit }, roleId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/role/${roleId}/permissionlite`);
      commit('SET_PERMISSION', sortBy(data, 'rolePermissionId'));
    } catch (err) {
      throw err;
    }
  },

  async savePermission({ commit }, { roleId, permissions }) {
    try {
      await window.axios.put(`/api/role/${roleId}/permissionlite`, permissions);
      commit('SET_PERMISSION', permissions);
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
